import Vue from 'vue';

export function childList () {
  return Vue.axios({
    url: '/api/child/list',
    method: 'get'
  })
}
